<template>
  <BaseModal
    :hide-overflow="false"
    :modal-name="name"
    max-width="max-w-xl"
    @close="onCloseModal"
  >
    <div class="flex flex-col items-center">
      <p
        class="text-center tracking-tight text-darkestGray"
        v-html="$t('to_continue_select_collection_point')"
      ></p>
      <BaseButton
        class="group relative mt-8 flex flex-col justify-center pr-12"
        theme="secondary"
        @click="onClickChooseCollectionPoint"
      >
        {{ $t('action.choose_facility') }}
        <inline-svg
          :src="useAsset(`icons/base/alab_marker.svg`)"
          class="absolute right-[16px]"
        />
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import InlineSvg from 'vue-inline-svg'
import { useModalsStore } from '~/stores/modals'
import { useCartStore } from '~/stores/cart'

const name = 'selectCollectionPointToContinue'

const {
  public: { baseUrl },
} = useRuntimeConfig()

const router = useRouter()
const route = useRoute()
const modalStore = useModalsStore()
const cartStore = useCartStore()

const onClickChooseCollectionPoint = () => {
  router.push({
    path: '/punkty-pobran',
    query: { returnTo: `${baseUrl}${route.fullPath}` },
  })
  modalStore.close(name)
}

const onCloseModal = () => {
  cartStore.clearItems()
  cartStore.isAddingToCart = false
}
</script>
